export default __webpack_public_path__ + "static/media/box2.fa81d4fd.jpg";